<template>
    <v-dialog v-model="dialog" max-width="700px">
      <template v-slot:activator="{ on }">
        <v-layout row justify-center>
        <v-flex xs10 style="text-align: center; border-radius: 8px;" class="gradient-purple">
          <h4 style="color: white;">Newsletteranmeldung</h4>
          <p style="color: white;">Einmal monatlich schicken wir dir interessante Quellen und Neuigkeiten von Ideenpioniere.</p>
          <v-btn outline v-on="on" color="white" class="elevation-0" target="_blank">Anmeldemaske öffnen <v-icon right>keyboard_arrow_right</v-icon></v-btn>
        </v-flex>
        </v-layout>
      </template>
      <v-card>
        <v-img
          class="white--text"
          :src="require('@/assets/header-newsletteranmeldung@2x.png')"
          cover
          height="200px"
        >
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
                <span class="headline">Newsletteranmeldung</span><br>
                <span class="text">Einmal monatlich schicken wir dir interessante Quellen und Neuigkeiten von Ideenpioniere.</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- Begin Mailchimp Signup Form -->
                <div id="mc_embed_signup">
                <form @submit="subscribe" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" method="POST" class="validate" target="_blank" novalidate>
                  <div id="mc_embed_signup_scroll">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field type="email" outline label="E-Mail Addresse*" id="mce-EMAIL" name="EMAIL" v-model="EMAIL" class="required email"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field type="text" outline label="Vorname" id="mce-FNAME" name="FNAME" v-model="FNAME" class=""></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field type="text" outline label="Nachname" id="mce-LNAME" name="LNAME" v-model="LNAME" class=""></v-text-field>
                      </v-flex>
                    </v-layout>
                    <div id="mergeRow-gdpr" class="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group">
                        <div class="content__gdpr">
                            <h4 style="font-weight: bold;">Erlaubnis zum Marketing</h4>
                            <p style="font-size: 12px;">IDEENPIONIERE wird die Informationen, die Sie in diesem Formular angeben, dazu verwenden, mit Ihnen in Kontakt zu bleiben und Ihnen Updates und Marketing-Informationen zu übermitteln. Bitte lassen Sie uns wissen, auf welche Art und Weise Sie von uns hören möchten:</p>
                            <v-checkbox id="gdpr_7561" v-model="selected" name="gdpr[7561]" label="E-Mail" value="Y" class="av-checkbox ">E-Mail</v-checkbox>
                            <p style="font-size: 12px;">Sie können Ihre Meinung jederzeit ändern, indem Sie auf den Abbestellungs-Link klicken, den Sie in der Fußzeile jeder E-Mail, die Sie von uns erhalten, finden können, oder indem Sie uns unter mindfulness@ideenpioniere.de kontaktieren. Wir werden Ihre Informationen mit Sorgfalt und Respekt behandeln. Weitere Informationen zu unseren Datenschutzpraktiken finden Sie auf unserer Website. Indem Sie unten klicken, erklären Sie sich damit einverstanden, dass wir Ihre Informationen in Übereinstimmung mit diesen Bedingungen verarbeiten dürfen.</p>
                        </div>
                        <div class="content__gdprLegal">  
                          <p style="font-size: 12px;">Wir nutzen Mailchimp als unsere Marketing-Plattform. Sobald Sie auf die unten stehende Schaltfläche "in Liste eintragen" klicken, bestätigen Sie, dass Ihre eingegebenen Informationen zur Verarbeitung an Mailchimp übermittelt werden. <a href="https://mailchimp.com/legal/" target="_blank">Erfahren Sie mehr über Mailchimps Datenschutzbestimmungen hier.</a></p>
                        </div>
                    </div>
                    <div id="mce-responses" class="clear">
                      <div class="response" id="mce-error-response" style="display:none"></div>
                      <div class="response" id="mce-success-response" style="display:none"></div>
                    </div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_80a2795ef220b97aa8cfac873_a5bd481755" tabindex="-1" value=""></div>
                    <v-btn flat outline @click="clear">schließen</v-btn>
                    <v-btn :disabled="!selected" color="warning" type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="elevation-0">in Liste eintragen</v-btn>
                    </div>
                </form>
                </div>

              <!--End mc_embed_signup-->
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      selected: false,
      dialog: false,
      EMAIL: '',
      FNAME: '',
      LNAME: ''
    }
  },
  methods: {
    clear () {
      this.selected = false
      this.dialog = false
    },
    subscribe () {
      document.getElementById('mc-embedded-subscribe-form').action = 'https://ideenpioniere.us14.list-manage.com/subscribe/post?u=80a2795ef220b97aa8cfac873&amp;id=a5bd481755'
      document.getElementById('mc-embedded-subscribe-form').submit()
      this.selected = false
      this.dialog = false
    }
  }
}
</script>

<style>
.v-dialog {
  border-radius: 8px;
}
.gradient-purple {
  background: #5E6A9A;
  background: -webkit-linear-gradient(to bottom right, #5E6A9A, #CC9BE5);
  background: -moz-linear-gradient(to bottom right, #5E6A9A, #CC9BE5);
  background: linear-gradient(to bottom right, #5E6A9A, #CC9BE5);
}
</style>
